import { trpc } from '@/trpc/client';

export const useCancelBookingMutation = () =>
  trpc.bookingManagement.cancelBooking.useMutation();
